import {
    Button,
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerOverlay,
    Flex,
    Modal,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import { BsChevronLeft } from 'react-icons/bs';
import { ProductDef, SubscriptionDef } from '../../service/inventory';
import config from '../../config';

interface CreatorSubscriptionData {
    products: ProductDef[];
    inventorySubscriptions: {
        [producID: string]: SubscriptionDef;
    };
    onPackageClick: (pkg: ProductDef) => void;
    isOpen: boolean;
    onClose: () => void;
}

export const CreatorSubscriptions: React.FC<CreatorSubscriptionData> = ({
    products,
    inventorySubscriptions,
    onPackageClick,
    isOpen,
    onClose,
}) => {
    const [selectedPackage, setSelectedPackage] = useState<ProductDef>(products[0]);

    const hasActiveSubscription = (productID: string): boolean => {
        return (
            inventorySubscriptions[productID] !== undefined &&
            !inventorySubscriptions[productID].status.inactive
        );
    };

    const onSubManageClick = () => {
        window.open(config.stripeCustomerPortalURL, '_blank');
    };

    const getErrorMsg = (productID: string): string => {
        const sub = inventorySubscriptions[productID];
        if (!sub || !sub.status || !sub.status.payload) {
            return '';
        }

        if (sub.status.payload.last_payment_error) {
            return sub.status.payload.last_payment_error.message;
        }
        if (sub.status.payload.last_finalization_error) {
            return sub.status.payload.last_finalization_error.message;
        }

        return '';
    };

    const renderContent = () => {
        return (
            <Flex className={'creator-subscriptions'}>
                <Flex className={'creator-subscriptions-header'}>
                    <Text>Subscription</Text>
                    <Text className={'creator-header-text'}>75% goes directly to the creator</Text>
                </Flex>
                <Flex className="divider" />
                <Flex className={'creator-subscriptions-body'}>
                    {products.map((pkg, i) => (
                        <Flex
                            key={i}
                            className={
                                pkg.product_id === selectedPackage.product_id
                                    ? 'creator-tier selected'
                                    : 'creator-tier'
                            }
                            onClick={() => {
                                setSelectedPackage(pkg);
                            }}
                        >
                            <Text>
                                {pkg.product_name} - {pkg.cost[0].quantity} ({pkg.cost[0].currency})
                                monthly {hasActiveSubscription(pkg.product_id) ? '(ACTIVE)' : ''}
                            </Text>
                        </Flex>
                    ))}
                </Flex>
                <Flex className="divider" />
                <Flex className={'creator-subscriptions-footer'}>
                    {hasActiveSubscription(selectedPackage.product_id) ? (
                        <Button
                            onClick={() => {
                                onSubManageClick();
                            }}
                        >
                            {`${
                                getErrorMsg(selectedPackage.product_id) !== ''
                                    ? getErrorMsg(selectedPackage.product_id)
                                    : 'MANAGE'
                            }`}
                        </Button>
                    ) : (
                        <Button
                            onClick={() => {
                                onPackageClick(selectedPackage);
                            }}
                        >
                            PURCHASE
                        </Button>
                    )}
                </Flex>
            </Flex>
        );
    };

    return (
        <>
            <MobileView>
                <Drawer isOpen={isOpen} placement={'bottom'} onClose={onClose}>
                    <DrawerOverlay />
                    <DrawerContent>
                        <BsChevronLeft className={'creator-subscriptions-back'} onClick={onClose} />
                        <DrawerBody>{renderContent()}</DrawerBody>
                    </DrawerContent>
                </Drawer>
            </MobileView>
            <BrowserView>
                <Modal isOpen={isOpen} onClose={onClose} isCentered>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalCloseButton />
                        {renderContent()}
                    </ModalContent>
                </Modal>
            </BrowserView>
        </>
    );
};
